import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_template_message_line_RowInterface {
guid: fromDatatype.GuidDataFieldInterface;
hdr_guid: fromDatatype.GuidDataFieldInterface;
app_file_item_guid: fromDatatype.GuidDataFieldInterface;
code: fromDatatype.VarcharDatatypeInterface;
name: fromDatatype.VarcharDatatypeInterface;
language_code: fromDatatype.VarcharDatatypeInterface;
description: fromDatatype.TextDatatypeInterface;
ext_type: fromDatatype.VarcharDatatypeInterface;
ext_code: fromDatatype.VarcharDatatypeInterface;
ext_option: fromDatatype.TextDatatypeInterface;
param_code: fromDatatype.VarcharDatatypeInterface;
param_name: fromDatatype.VarcharDatatypeInterface;
param_type: fromDatatype.VarcharDatatypeInterface;
param_option_json: fromDatatype.JsonDatatypeInterface;
value_string: fromDatatype.TextDatatypeInterface;
value_file: fromDatatype.VrsnDataFieldInterface;
value_numeric: fromDatatype.NumericDatatypeInterface;
value_datetime: fromDatatype.TimestampTzDatatypeInterface;
value_json: fromDatatype.JsonDatatypeInterface;
namespace: fromDatatype.VrsnDataFieldInterface;
obj_type: fromDatatype.VrsnDataFieldInterface;
property_json: fromDatatype.JsonDatatypeInterface;
acl_config: fromDatatype.JsonDatatypeInterface;
acl_policy: fromDatatype.JsonDatatypeInterface;
module_guid: fromDatatype.GuidDataFieldInterface;
applet_guid: fromDatatype.GuidDataFieldInterface;
created_date: fromDatatype.TimestampTzDatatypeInterface;
updated_date: fromDatatype.TimestampTzDatatypeInterface;
created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
status: fromDatatype.VarcharDatatypeInterface;
revision: fromDatatype.GuidDataFieldInterface;
vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_applet_template_message_line_RowClass implements bl_applet_template_message_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    app_file_item_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    language_code: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    ext_type: fromDatatype.VarcharDatatypeInterface;
    ext_code: fromDatatype.VarcharDatatypeInterface;
    ext_option: fromDatatype.TextDatatypeInterface;
    param_code: fromDatatype.VarcharDatatypeInterface;
    param_name: fromDatatype.VarcharDatatypeInterface;
    param_type: fromDatatype.VarcharDatatypeInterface;
    param_option_json: fromDatatype.JsonDatatypeInterface;
    value_string: fromDatatype.TextDatatypeInterface;
    value_file: fromDatatype.VrsnDataFieldInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime: fromDatatype.TimestampTzDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VrsnDataFieldInterface;
    obj_type: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    }